import React, { useState } from "react";
import DialogWrapper from "../../custom-ui/dialog/Dialog";
import { useCreateCommunityHub } from "../../../data/communityHub";
import toast from "react-hot-toast";

export default function NewHubModal({
  onClose,
  moderatorBy,
}: {
  onClose: () => void;
  moderatorBy: { email: string; name: string };
}) {
  const createHub = useCreateCommunityHub();
  const [hubName, setHubName] = useState("");
  const [location, setLocation] = useState("");
  const [descriptions, setDescriptions] = useState("");

  const handleSubmit = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    if (!hubName.trim()) {
      toast.error("Hub name is required");
      return;
    }
    if (!descriptions.trim()) {
      toast.error("Description is required");
      return;
    }
    try {
      await createHub.mutateAsync({
        hubName: hubName.trim(),
        location: location.trim(),
        descriptions: descriptions.trim(),
        moderatorBy,
      });
      toast.success("Community hub created");
      onClose();
    } catch {
      toast.error("Failed to create hub");
    }
  };

  return (
    <DialogWrapper
      title="New Community Hub"
      size="max-w-lg"
      onClose={onClose}
      displayCloseIcon
    >
      <form onSubmit={handleSubmit} className="p-6 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Hub name
          </label>
          <input
            value={hubName}
            onChange={(e) => setHubName(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
            placeholder=""
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Location{" "}
            <span className="text-xs font-normal text-gray-500 italic">
              (optional)
            </span>
          </label>
          <input
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
            placeholder=""
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Description
          </label>
          <textarea
            value={descriptions}
            onChange={(e) => setDescriptions(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm min-h-[100px]"
            placeholder="Describe this community hub."
            required
          />
        </div>
        <div className="flex justify-end gap-3 pt-2">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100 rounded-lg"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={createHub.isLoading}
            className="px-4 py-2 text-sm font-semibold text-white bg-instant-teams-teal-Main rounded-lg hover:opacity-90 disabled:opacity-50"
          >
            {createHub.isLoading ? "Creating…" : "Create Hub"}
          </button>
        </div>
      </form>
    </DialogWrapper>
  );
}
